module.exports = __webpack_public_path__ + "img/Your-home-symbol.dc12943c.svg";